import { Box, Grow, LinearProgress, Stack } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";

import LogoKapuas from "../img/Logo Kapuas.png";
import dpmptsp from "../img/logo-dpmptsp.png";
import PotensiPage from "../page/Potensi";
import { Route, Routes, useNavigate } from "react-router-dom";
import DashboardPage from "../page/Dashboard";
import API from "./RestApi.json";
import PotensiForm from "../page/potensi-page/Potensi-Form";
import UploadPage from "../page/UploadPage";
import PeluangForm from "../page/peluang-page/Peluang-Form";
import PeluangPage from "../page/Peluang";
import InfrastrukturPage from "../page/Infrastruktur";
import InfrastrukturForm from "../page/infrastruktur-page/Infrastruktur-Form";
import KomponenPage from "../page/Komponen";
import PenggunaPage from "../page/Pengguna";
import PenggunaForm from "../page/pengguna-page/Pengguna-Form";
import LoginPage from "../page/login";
import ArtikelForm from "../page/artikel-page/Artikel-Form";
import ArtikelPage from "../page/Artikel";
import DaerahPage from "../page/Daerah";
import DaerahForm from "../page/daerah-page/Daerah-Form";
import Galeri_Dokumen from "../page/Galeri_Dokumen";

export default function ApiController(params) {
  const goTo = useNavigate();
  const [potensi, setPotensi] = useState(-1);
  const [peluang, setPeluang] = useState(-1);
  const [infrastruktur, setInfrastruktur] = useState(-1);
  const [artikel, setArtikel] = useState(-1);
  const [pengguna, setPengguna] = useState(-1);
  const [komponen, setKomponen] = useState(-1);
  const [file, setFile] = useState(-1);

  const [checked, setChecked] = useState(1);

  useEffect(() => {
    axios.get(API.potensi).then((response) => {
      setTimeout(() => {
        // setChecked(false);
        setPotensi(response.data);
      }, 100);
    });
  }, []);

  useEffect(() => {
    axios.get(API.peluang).then((response) => {
      setTimeout(() => {
        // setChecked(false);
        setPeluang(response.data);
      }, 100);
    });
  }, []);
  // console.log(peluang);

  useEffect(() => {
    axios.get(API.infrastruktur).then((response) => {
      setTimeout(() => {
        // setChecked(false);
        setInfrastruktur(response.data);
      }, 100);
    });
  }, []);

  useEffect(() => {
    axios.get(API.pengguna).then((response) => {
      setTimeout(() => {
        // setChecked(false);

        const check = response.data.filter(
          (item) => item.remember_token == localStorage.getItem("token")
        );

        if (checked > 0) {
          setPengguna(response.data);
        } else {
          setChecked(check);
        }
      }, 100);
    });
  }, []);

  // console.log(infrastruktur);
  useEffect(() => {
    axios.get(API.komponen).then((response) => {
      setTimeout(() => {
        // setChecked(false);
        setKomponen(response.data);
      }, 100);
    });
  }, []);
  // console.log(infrastruktur);
  useEffect(() => {
    axios.get(API.artikel).then((response) => {
      setTimeout(() => {
        // setChecked(false);
        setArtikel(response.data);
      }, 100);
    });
  }, []);

  // console.log(infrastruktur);
  useEffect(() => {
    axios.get(API.file).then((response) => {
      setTimeout(() => {
        // setChecked(false);
        setFile(response.data);
      }, 150);
    });
  }, []);

  return potensi.length > -1 &&
    peluang.length > -1 &&
    infrastruktur.length > -1 &&
    artikel.length > -1 &&
    file.length > -1 &&
    pengguna.length > -1 ? (
    <Routes>
      <Route
        path="/"
        element={
          <DashboardPage
            data={{
              potensi: potensi.length,
              peluang: peluang.length,
              infrastruktur: infrastruktur.length,
              pengguna: pengguna.length,
            }}
          />
        }
      />

      <Route
        path="potensi"
        element={<PotensiPage data={potensi} file={file} />}
      />
      <Route path="potensi-form" element={<PotensiForm />} />
      <Route
        path="peluang"
        element={<PeluangPage data={peluang} file={file} />}
      />
      <Route path="peluang-form" element={<PeluangForm />} />
      <Route
        path="infrastruktur"
        element={<InfrastrukturPage data={infrastruktur} file={file} />}
      />
      <Route path="infrastruktur-form" element={<InfrastrukturForm />} />

      <Route
        path="artikel"
        element={<ArtikelPage data={artikel} file={file} />}
      />
      <Route path="artikel-form" element={<ArtikelForm />} />

      <Route
        path="daerah"
        element={<DaerahPage data={artikel} file={file} />}
      />
      <Route path="daerah-form" element={<DaerahForm />} />

      <Route path="pengguna" element={<PenggunaPage data={pengguna} />} />
      <Route path="pengguna-form" element={<PenggunaForm />} />

<Route
        path="file"
        element={<Galeri_Dokumen file={file} />}
      />

      <Route
        path="komponen"
        element={<KomponenPage data={komponen} file={file} />}
      />

      <Route path="upload-page" element={<UploadPage data={file} />} />

      {/* <Route path="peluang" element={<PeluangPage data={peluang} />} />
      <Route
        path="infrastruktur"
        element={<InfrastrukturPage data={infrastruktur} />}
      /> */}
    </Routes>
  ) : checked == 0 ? (
    <LoginPage />
  ) : (
    <Grow in={true} mountOnEnter unmountOnExit>
      <Box
        height={"100vh"}
        width={"100%"}
        justifyContent={"center"}
        alignContent={"center"}
      >
        <Stack
          height={"50%"}
          width={"25%"}
          justifySelf={"center"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Box
            component="img"
            sx={{
              maxHeight: { xs: 100, md: 75, lg: 150 },
              maxWidth: { xs: 100, md: 75, lg: 150 },
              mb: 1,
            }}
            alt="Kabupaten Kapuas."
            src={LogoKapuas}
          />
          <Box
            component="img"
            sx={{
              maxHeight: { xs: 100, md: 200, lg: 250 },
              maxWidth: { xs: 100, md: 200, lg: 250 },
              mb: 2,
            }}
            alt="Kabupaten DPMPTSP."
            src={dpmptsp}
          />
          <Box width={"100%"}>
            <LinearProgress />
          </Box>
        </Stack>
      </Box>
    </Grow>
  );
}
